import { findFirst } from "../../../../../../../../utils/arrays";
import { templateParser } from "../../../../../../../../utils/strings";
import { EConstant } from "./constants";
export var converter = function converter(_ref) {
  var _onClick = _ref.onClick,
    text = _ref.text,
    countdownText = _ref.countdownText,
    _ref$countdown = _ref.countdown,
    value = _ref$countdown.value,
    reset = _ref$countdown.reset;
  var minutes = Math.floor(value / EConstant.Hour);
  var seconds = value % EConstant.Hour;
  var hasElapsed = value <= 0;
  var time = [minutes, seconds] //
  .map(function (_value) {
    return _value.toString().padStart(2, '0');
  }).join(':');
  var _text = findFirst([!hasElapsed && templateParser(countdownText, {
    time: time
  }), text]);
  var onClick = function onClick() {
    if (!hasElapsed) return;
    _onClick();
    reset();
  };
  return {
    children: _text,
    hasElapsed: hasElapsed,
    onClick: onClick
  };
};